'use client';

import { ReactNode, useEffect, useState } from 'react';
import {
  AccordionContainer,
  AccordionContent,
  AccordionHeader,
  ArrowIcon,
  FiltersContainer,
  LabelWithHint,
} from './styled';
import { Box, Typography } from '@mui/material';
import { Hint } from '@/components';
import { splitLastWord } from '@/utils/splitLastWord';

export const FilterAccordion = ({
  title,
  children,
  id,
  $borderless,
  hint,
  defaultOpen = true,
}: {
  title: string;
  children: ReactNode;
  id: string;
  $borderless?: boolean;
  hint?: string;
  defaultOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const labelParts = hint ? splitLastWord(title) : null;

  useEffect(() => {
    const storedValue = localStorage.getItem(id);
    if (storedValue !== null) setIsOpen(JSON.parse(storedValue));
  }, [id]);

  useEffect(() => {
    localStorage.setItem(id, JSON.stringify(isOpen));
  }, [isOpen, id]);

  return (
    <AccordionContainer $borderless={$borderless}>
      <AccordionHeader onClick={() => setIsOpen(!isOpen)}>
        <Typography
          fontSize={16}
          fontWeight={700}
          lineHeight={'125%'}
          sx={{ flex: 1, minWidth: 0 }}
        >
          {labelParts && hint ? (
            <>
              {labelParts.leading}
              {labelParts.leading ? ' ' : null}
              <LabelWithHint>
                {labelParts.lastWord}
                <Box
                  component="span"
                  onClick={(event) => event.stopPropagation()}
                  onMouseDown={(event) => event.stopPropagation()}
                  sx={{ display: 'inline-flex', verticalAlign: 'top', ml: '4px' }}
                >
                  <Hint message={hint} />
                </Box>
              </LabelWithHint>
            </>
          ) : (
            title
          )}
        </Typography>
        <ArrowIcon
          $isOpen={isOpen}
          width="17"
          height="16"
          viewBox="0 0 17 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.06462 12.9517C0.814397 12.7014 0.673829 12.362 0.673829 12.0081C0.673829 11.6542 0.814397 11.3147 1.06462 11.0644L7.73824 4.39082C7.98853 4.1406 8.32797 4.00003 8.68189 4.00003C9.03581 4.00003 9.37524 4.1406 9.62554 4.39082L16.2992 11.0644C16.5423 11.3162 16.6768 11.6533 16.6738 12.0033C16.6707 12.3532 16.5304 12.688 16.2829 12.9355C16.0354 13.1829 15.7007 13.3233 15.3507 13.3264C15.0007 13.3294 14.6636 13.1949 14.4119 12.9517L8.68189 7.22177L2.95192 12.9517C2.70162 13.202 2.36219 13.3425 2.00827 13.3425C1.65435 13.3425 1.31492 13.202 1.06462 12.9517Z"
          />
        </ArrowIcon>
      </AccordionHeader>

      <AccordionContent $isOpen={isOpen}>
        <FiltersContainer>{children}</FiltersContainer>
      </AccordionContent>
    </AccordionContainer>
  );
};
